import { useQuery } from '@tanstack/react-query';
import { localizedReferenceDataKeys } from '@/locales/localizedReferenceData';
import { useAppLocale } from '@/locales/useAppLocale';
import { fetchCountries } from '../api/countriesApi';

export const countriesKeys = {
  all: localizedReferenceDataKeys.countries,
  list: (locale: string) => [...countriesKeys.all, 'list', locale] as const,
};

export function useCountries() {
  const locale = useAppLocale();

  return useQuery({
    queryKey: countriesKeys.list(locale),
    queryFn: () => fetchCountries(locale),
    staleTime: 1000 * 60 * 60, // 1 hour - countries don't change often
  });
}
